import { render, staticRenderFns } from "./titlePart.vue?vue&type=template&id=487d6c5b&"
import script from "./titlePart.vue?vue&type=script&lang=js&"
export * from "./titlePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('487d6c5b', component.options)
    } else {
      api.reload('487d6c5b', component.options)
    }
    module.hot.accept("./titlePart.vue?vue&type=template&id=487d6c5b&", function () {
      api.rerender('487d6c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/titlePart.vue"
export default component.exports